




/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const REGISTERPOST= createAsyncThunk(
  "RegisterPost/RegisterPost",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const RegisterPostSlice = createSlice({
  name: "RegisterPostSlice",
  initialState: {
    RegisterPost: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfRegisterPost: (state) => {
        state.RegisterPost.loading = false
        state.RegisterPost.error = false
        state.RegisterPost.data = []
        state.RegisterPost.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(REGISTERPOST.fulfilled, (state, action) => {
      state.RegisterPost = {
        ...state.RegisterPost,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(REGISTERPOST.pending, (state, action) => {
      state.RegisterPost = {
        ...state.RegisterPost,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(REGISTERPOST.rejected, (state, action) => {
      state.RegisterPost = {
        ...state.RegisterPost,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const RegisterPostAction = {
    REGISTERPOST,
};

export { RegisterPostAction };
export default RegisterPostSlice.reducer;
export const {setInitialStateOfRegisterPost} = RegisterPostSlice.actions
